import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../config/api.js';

export default function SpotifyModule({ user }) {
  const [spotifyData, setSpotifyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSpotifyData();
  }, []);

  const fetchSpotifyData = async () => {
    try {
      const artistId = user?.artistId || 'rdv01'; // Use user's artistId or default
      const response = await fetch(`${API_BASE_URL}/spotify/analytics?artistId=${encodeURIComponent(artistId)}`);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      setSpotifyData(data);
    } catch (error) {
      console.error('Error fetching Spotify data:', error);
      setError('Failed to load Spotify analytics');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="professional-loading">
        Loading Spotify analytics...
      </div>
    );
  }

  if (error) {
    return (
      <div className="professional-error">
        Error: {error}
      </div>
    );
  }

  return (
    <div className="professional-container">
      <div className="professional-header">
        <h1>🎵 Spotify Analytics</h1>
        <p>Real-time streaming data and performance insights</p>
      </div>
      
      {spotifyData && (
        <div className="professional-grid-3">
          <div className="professional-metric-card">
            <div className="professional-metric-value">{spotifyData.processedArtists?.length || 0}</div>
            <div className="professional-metric-label">Artists Processed</div>
            <div className="professional-metric-change">Total artists tracked</div>
          </div>

          <div className="professional-metric-card">
            <div className="professional-metric-value">{spotifyData.saved || 0}</div>
            <div className="professional-metric-label">Data Points Saved</div>
            <div className="professional-metric-change">Analytics records stored</div>
          </div>

          <div className="professional-card">
            <div className="professional-card-header">
              <h3 className="professional-card-title">Artist Mapping</h3>
            </div>
            <div className="professional-card-content">
              {spotifyData.artistMapping ? (
                <ul className="professional-list">
                  {Object.entries(spotifyData.artistMapping).map(([key, value]) => (
                    <li key={key} className="professional-list-item">
                      <div className="professional-list-item-content">
                        <div className="professional-list-item-title">{key}</div>
                      </div>
                      <div className="professional-list-item-value">{value}</div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No mapping data available</p>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="professional-card">
        <div className="professional-card-header">
          <h3 className="professional-card-title">📈 Spotify Integration Status</h3>
        </div>
        <div className="professional-card-content">
          <ul className="professional-list">
            <li className="professional-list-item">
              <div className="professional-list-item-content">
                <div className="professional-list-item-title">API Connection</div>
              </div>
              <div className="professional-list-item-value">✅ Connected</div>
            </li>
            <li className="professional-list-item">
              <div className="professional-list-item-content">
                <div className="professional-list-item-title">Data Sync</div>
              </div>
              <div className="professional-list-item-value">✅ Active</div>
            </li>
            <li className="professional-list-item">
              <div className="professional-list-item-content">
                <div className="professional-list-item-title">Weekly Updates</div>
              </div>
              <div className="professional-list-item-value">✅ Scheduled</div>
            </li>
            <li className="professional-list-item">
              <div className="professional-list-item-content">
                <div className="professional-list-item-title">Next Update</div>
              </div>
              <div className="professional-list-item-value">🔄 Sunday 2 AM PST</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
